// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"5105":"126ef875c71fd923","9812":"6cf54a157c503804"}[chunkId] + ".css";
};